module.exports = __webpack_public_path__ + "img/exmpl-ui_visible-block.2e34b936.png";